'use strict';

// Initiate mobile menu.
var mobileMenu = require('./mobileMenu');
mobileMenu.init()

// Initiate paralax.
var paralax = require('./paralax');
paralax.init();


// 
// Initial Scroll 'N Stick elements.
(function(){
	var $ = require('./functions');
	var _ = require('underscore');
	var ScrollNStick = require('./ScrollNStick');

	_.each($.el('.scroll-n-stick'), function( el ){
		new ScrollNStick(el);
	});
})();

// 
// Empty and hide spam prevention field.
(function(){
	var $ = require('./functions');
	var _ = require('underscore');

	_.each($.el('input[name=_gotcha]'), function(el){
		el.setAttribute('value', '');
	});

	_.each($.el('.js-hideme'), function(el){
		el.style.display = 'none';
	});
})();

